import React from 'react';
import { createRoot } from 'react-dom/client';
import {Provider} from 'react-redux';
import store from './redux/reducers';
import App from './App';
import * as serviceWorker from './serviceWorker';

import './index.scss';

const container = document.getElementById('root');
const root = createRoot(container);
root.render(
    <Provider store={store}>
        <App/>
    </Provider>
);

serviceWorker.unregister();
